import { call, put, takeEvery, fork } from 'redux-saga/effects';
import { normalize } from 'normalizr';
import { push } from 'react-router-redux';

import * as schemas from 'store/common/schemas';
import * as entityActions from 'store/entities/actions';
import * as actionTypes from './action-types';
import * as actions from './actions';
import * as api from 'api/config/companies';
import callApi from 'store/api/saga';
import { addMessage } from 'store/features/common/flash/actions';
import { buildMessage, messageTypes } from 'store/features/common/flash/builder';
import routeGenerators from 'ui/common/routes/generators';

function* fetchCompanyByPrettyId({ payload }) {
  const { prettyId } = payload;
  yield put(actions.fetchCompanyByPrettyId.start({ prettyId }));

  try {
    const response = yield call(callApi, api.fetchCompanyByPrettyId({ prettyId }));

    const schema = schemas.company;

    // ID-2024, hotfix, if the current company is a profiler_run, redirect to profiler_run details instead.
    if (response.features.profiler && (response.profiler || {}).id) {
      yield put(
        push(
          routeGenerators.profiler.details({ id: response.profiler.id, section: 'candidates' }),
          {
            flash: buildMessage({
              kind: messageTypes.success,
              content: 'Welcome to Entry Test Dashboard',
            }),
          }
        )
      );
    }
    const { entities } = normalize(response, schema);
    yield put(entityActions.mergeEntities(entities));
    yield put(actions.fetchCompanyByPrettyId.success({ prettyId }));
  } catch (error) {
    yield put(actions.fetchCompanyByPrettyId.failure({ prettyId, error }));
    yield put(addMessage({ kind: messageTypes.danger, content: error.message }));
  }
}

function* watchFetchCompanyByPrettyId() {
  yield takeEvery(actionTypes.FETCH_COMPANY_BY_PRETTY_ID.REQUEST, fetchCompanyByPrettyId);
}

function* fetchCompanyTeamMembersByPrettyId({ payload }) {
  const { prettyId } = payload;
  yield put(actions.fetchCompanyTeamMembersByPrettyId.start({ prettyId }));

  try {
    const response = yield call(callApi, api.fetchCompanyTeamMembersByPrettyId({ prettyId }));
    const schema = [schemas.companyTeamMemberConnection];
    const { entities, result } = normalize(response, schema);
    yield put(entityActions.mergeEntities(entities));
    yield put(
      actions.fetchCompanyTeamMembersByPrettyId.success({ prettyId, teamMemberIds: result })
    );
  } catch (error) {
    yield put(actions.fetchCompanyTeamMembersByPrettyId.failure({ prettyId, error }));
  }
}

function* watchFetchCompanyTeamMembersByPrettyId() {
  yield takeEvery(
    actionTypes.FETCH_COMPANY_TEAM_MEMBERS_BY_PRETTY_ID.REQUEST,
    fetchCompanyTeamMembersByPrettyId
  );
}

function* fetchCompanyAdvisorsByPrettyId({ payload }) {
  const { prettyId } = payload;
  yield put(actions.fetchCompanyAdvisorsByPrettyId.start({ prettyId }));

  try {
    const response = yield call(callApi, api.fetchCompanyAdvisorsByPrettyId({ prettyId }));
    const schema = [schemas.companyAdvisorConnection];
    const { entities, result } = normalize(response, schema);
    yield put(entityActions.mergeEntities(entities));
    yield put(actions.fetchCompanyAdvisorsByPrettyId.success({ prettyId, advisorIds: result }));
  } catch (error) {
    yield put(actions.fetchCompanyAdvisorsByPrettyId.failure({ prettyId, error }));
  }
}

function* watchFetchCompanyAdvisorsByPrettyId() {
  yield takeEvery(
    actionTypes.FETCH_COMPANY_ADVISORS_BY_PRETTY_ID.REQUEST,
    fetchCompanyAdvisorsByPrettyId
  );
}

export default function* companiesSaga() {
  yield fork(watchFetchCompanyByPrettyId);
  yield fork(watchFetchCompanyTeamMembersByPrettyId);
  yield fork(watchFetchCompanyAdvisorsByPrettyId);
}



// WEBPACK FOOTER //
// ./src/store/features/companies/saga.js